<template>
  <div id="shop-product-dialog">
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark small v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xs py-0>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4>
                <ShopEditionProductItemPicture :idx="formData.idx" v-if="formData.idx" />
              </v-flex>
              <v-flex xs12>
                <v-text-field clearable label="Name" v-model="formData.name"></v-text-field>
              </v-flex>
            </v-layout>
            <!-- Section 1 -->
          </v-container>
          <ShopEditionProductItemPriceTable v-if="formData.idx" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            @click="doDelete(formData.idx, formData.picture)"
            color="red"
            dark
            v-if="formData.idx"
            >Delete</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn @click.prevent="doSubmit()" color="green" dark :loading="dialogLoading"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firestorage from 'firebase/app' // Storage
const ShopEditionProductItemPicture = () =>
  import('@/components/admin/ShopEditionProductItemPicture')
const ShopEditionProductItemPriceTable = () =>
  import('@/components/admin/ShopEditionProductItemPriceTable')

export default {
  name: 'shop-product-dialog',
  components: {
    ShopEditionProductItemPriceTable,
    ShopEditionProductItemPicture
  },
  data() {
    return {
      formData: [],
      dialogLoading: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.ShopEditionProductItem.idx) {
        this.formData = this.$store.getters['ShopEditionProductItem/getAll'].filter(
          item => item.idx == this.$store.state.ShopEditionProductItem.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    dialogItem: {
      // getter
      get() {
        return this.$store.state.ShopEditionProductItem.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('ShopEditionProductItem/UPDATE_DIALOG', newValue)
      }
    }
  },
  created() {},
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            ...this.formData,
            shopEditionProductId: this.$store.state.ShopEditionProduct.idx
          }
          await this.$store.dispatch(`ShopEditionProductItem/insert`, data)
          this.$store.commit(`ShopEditionProductItem/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    doDelete(idx, picture) {
      const answer = window.confirm(`Do you want to Delete ${idx} ?`)
      if (answer) {
        if (picture) {
          // Create a reference to the file to delete
          var desertRef = firestorage.storage().refFromURL(picture)
          // Delete the file
          desertRef.delete()
        }
        // Delete in DB
        this.$store.dispatch(`ShopEditionProductItem/delete`, idx)
        this.$store.commit(`ShopEditionProductItem/UPDATE_DIALOG`, false)
      }
    },
    addItem() {
      this.$store.commit('ShopEditionProductItem/UPDATE_DIALOG', true)
      this.$store.commit('ShopEditionProductItem/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
